

















































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import PaperlessManagementTableComponent from "@/components/shipments/PaperlessManagementTable.vue";
import PaperlessManagementTable from "@/components/shipments/PaperlessManagementTable.vue";
import Accordion from "@/components/shared/Accordion.vue";
import AddPaperlessDocumentModalComponent from "@/components/shipments/AddPaperlessDocumentModal.vue";
import { ShipmentService } from "@/services/ShipmentService";

@Component({
  components: {
    PaperlessManagementTable: PaperlessManagementTableComponent,
    Accordion: Accordion,
    AddPaperlessDocumentModal: AddPaperlessDocumentModalComponent
  }
})
export default class PaperlessManagement extends Vue {
  filters = {
    documentType: null,
    courier: undefined
  };
  showAddPaperlessModal = false;
  selectedDocuments = [];
  documentTypes: any[] = [];
  couriers: any[] = [];
  filtersAccordionActive = true;

  @Watch("filters.documentType", {})
  onDocumentType() {
    if (this.filters.documentType && this.canSelectCourier) {
      this.couriers = [];
      this.filters.courier = undefined;
      const selectedDocument: any = this.documentTypes.filter(
        item => item.id === this.filters.documentType
      )[0];
      Object.keys(selectedDocument.allowedCouriers).forEach((item: any) => {
        const courier: any = {
          id: Number(item),
          label: selectedDocument.allowedCouriers[item]
        };
        this.couriers.push(courier);
      });
    }
  }

  created() {
    this.fetchDocTypes();
  }

  search() {
    this.filtersAccordionActive = false;
    if (!this.filters.documentType) this.filters.documentType = "";
    (this.$refs.paperless_table as PaperlessManagementTable).search();
  }

  toggleAddPaperlessModal() {
    this.showAddPaperlessModal = !this.showAddPaperlessModal;
  }
  handleSelectedPaperlessChange(selected: number[]) {
    if (selected.length > 0) {
      this.selectedDocuments = selected;
    } else {
      this.selectedDocuments = [];
    }
  }
  resetFilters() {
    this.filters = {
      documentType: null,
      courier: undefined
    };
  }
  fetchDocTypes() {
    ShipmentService.prototype
      .getAvailablePaperlessDocumentTypes()
      .then((res: any) => {
        this.documentTypes = res;
      });
  }
  deletePaperlessDocuments() {
    (this.$refs
      .paperless_table as PaperlessManagementTable).deletePaperlessDocuments();
  }
  get selectedFiltersValues() {
    let filter = "";
    Object.keys(this.filters).forEach((item: any) => {
      if (item === "documentType" && this.filters[item]) {
        const selectedDocument = this.documentTypes.filter(item => {
          return item.id === this.filters.documentType;
        })[0];
        filter += `${selectedDocument.description}, `;
      }
    });
    filter.trim();
    if (filter.endsWith(",")) filter.slice(filter.length - 1);
    return filter;
  }
  get canSelectCourier() {
    return this.$store.getters["customer/config"].canSelectCourier;
  }
}
